<ul class="navbar-nav me-auto mb-2 mb-lg-0">
  <!-- Product Master -->
  <li class="nav-item">
    <a class="nav-link" routerLink="/product-master" routerLinkActive="active"
       [routerLinkActiveOptions]="{exact: true}">
      <i class="fa fa-cube me-1"></i>Product Master
    </a>
  </li>

  <!-- Net Benefit Report -->
  <li class="nav-item">
    <a class="nav-link" routerLink="/reports/heroNetBenefitReport" routerLinkActive="active">
      <i class="fa fa-bar-chart me-1"></i>Net Benefit Report
    </a>
  </li>
</ul>
